export const SYSTEM_GENERATED_COLLECTION_TYPE_ID = 22;
export const ACCOUNT_COLLECTION_TYPE_ID = 2;
